import { useSelector } from "react-redux";

import t from "../../../i18n/i18n";

import Membership from "../../../components/membership/membership";

function UserBox() {
  const { user } = useSelector((store) => store.auth);
  const { avatar, name, nickname, credits } = user;

  return (
    <div className="chargin-box-panel">
      <div className="title-header">
        <div className="icon-shap">
          <img src="/images/doller-large.png" alt="" />
        </div>
        <h1>{t("RechargeCenter.RechargeCenter")}</h1>
      </div>
      <div className="profile-panel-box">
        <div className="profile-col">
          <div className="user-name-info">
            <span className="user-thumb">
              <img src={avatar || "/images/user-thumn-m.png"} alt="" />
            </span>
            <div className="user-name-title">
              {nickname && <span className="name">{nickname}</span>}
              <small>@{name}</small>
            </div>
          </div>
        </div>
        <div className="membership-panel-col">
          <div className="membership-inner">
            <div className="credit-data">
              <span className="icon">
                <img src="/images/credit-ico-large.png" alt="" />
              </span>
              {t("RechargeCenter.YouHave")} <h6>{credits || 0}</h6>
              <small>{t("RechargeCenter.Credits")}</small>
            </div>
            <div className="membership-colwarp black">
              <Membership user={user} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserBox;
